import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { CoffeeBreakIllustration } from './CoffeeBreak';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const CoffeeBreak = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <CoffeeBreakIllustration title={title} />
  </IllustrationWrapper>
);
